import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import BodyClassName from 'react-body-classname'

import Loader from '../Loader'

import './LoaderOverlay.css'

const LoaderOverlay = () => {
  return (
    <div className='loader-overlay'>
      <Loader />
    </div>
  )
}

LoaderOverlay.Toggle = ({ active }) => {
  const bodyClassName = classNames({
    'loader-overlay-active': active,
  })

  return <BodyClassName className={bodyClassName} />
}

LoaderOverlay.Toggle.propTypes = {
  active: PropTypes.bool,
}

export default LoaderOverlay



// WEBPACK FOOTER //
// ./src/Components/LoaderOverlay/LoaderOverlay.js